import { apiClient } from "./client";

export interface PlanHour {
  hour: number;
  power_kw: number | string;
  volumes: Record<string, number | string>;
}

export interface Plan {
  id: string;
  tenant_id: string;
  plan_date: string;
  last_updated_at: string;
  last_updated_by: string | null;
  submitted_at: string | null;
  hours: PlanHour[];
}

export interface PlanHourWrite {
  power_kw: number;
  volumes: Record<string, number>;
}

export type CopyFromSource = "yesterday" | "weekly_avg";

export const plansApi = {
  get: (planDate: string) =>
    apiClient.get<Plan | null>(`/plans/${planDate}`).then((r) => r.data),

  putHour: (planDate: string, hour: number, body: PlanHourWrite) =>
    apiClient
      .put(`/plans/${planDate}/hour/${hour}`, body)
      .then((r) => r.data),

  copyFrom: (planDate: string, source: CopyFromSource) =>
    apiClient
      .post<Plan>(`/plans/${planDate}/copy-from`, null, { params: { source } })
      .then((r) => r.data),

  submit: (planDate: string) =>
    apiClient.post<Plan>(`/plans/${planDate}/submit`).then((r) => r.data),

  unsubmit: (planDate: string) =>
    apiClient.post<Plan>(`/plans/${planDate}/unsubmit`).then((r) => r.data),
};
